import React from "react";
import Setup2FA from "../auth/Setup2FA";

const OptionsSetup2FA = () => {
  return <Setup2FA isFromOptions />;
};

export default OptionsSetup2FA;
